module.exports = __webpack_public_path__ + "fonts/unicredit-bold.e99ca0e6.woff";